module.exports = __webpack_public_path__ + "static/media/model.fa7af228.glb";